import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { Select } from "components/Select/Select";
import { useFormik } from "formik";
import { TipoEspacioI } from "interfaces/TipoEspacio";

import { useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { createTipoEspacioSchema } from "schemas/tipoEspacio/CreateTipoEspacioSchema";
import { createTitulosSchema } from "schemas/titulos/createTitulosSchema";
import { postTipoEspacio, putTipoEspacio } from "services/tipoEspacio";
import { postTitulo, putTitulo } from "services/titulos";
import { RootState } from "store/store";
import { isNoSelected, SI_NO_OPCIONES_SELECT } from "utils/selectUtils";

interface Props {
  actionType: "create" | "edit" | undefined;
  onClose?: any;
  elemento?: TipoEspacioI;
  onSuccess?: (titulo: TipoEspacioI) => void;
  showModal: boolean;
}

interface initialValues {
  id?: string | number;
  nombre: string;
  con_sub_tipo: boolean;
}

export const TipoEspacioABM = ({
  showModal,
  actionType,
  onClose,
  elemento,
  onSuccess,
}: Props) => {
  const isEditMode = actionType == "edit";
  const initialValues: initialValues = {
    nombre: "",
    con_sub_tipo: false,
  };

  const renderInitialValues = async () => {
    let currentValues;

    if (isEditMode && elemento) {
      currentValues = {
        id: elemento?.id ?? "",
        nombre: elemento?.nombre ?? "",
        con_sub_tipo: elemento?.con_sub_tipo ?? false,
      };
    } else {
      currentValues = initialValues;
    }
    setValues(currentValues);
  };

  const handleSubmitCreate = async (params: any) => {
    try {
      const con_sub_tipo = !isNoSelected(params.con_sub_tipo);
      const newTipoEspacio = await postTipoEspacio({
        params: { ...params, con_sub_tipo },
      });
      showSuccessToast("¡El tipo de espacio fue creado con éxito!");
      if (onSuccess) onSuccess(newTipoEspacio);
      onClose();
    } catch (err: any) {
      showErrorToast("El tipo de espacio no pudo ser creado.");
      console.log(err.message);
    }
  };

  const handleSubmitEdit = async (params: any) => {
    try {
      const newTipoEspacio = await putTipoEspacio({ params });
      showSuccessToast("¡El tipo de espacio fue editado con éxito!");
      if (onSuccess) onSuccess(newTipoEspacio);
      onClose();
    } catch (err: any) {
      showErrorToast("El tipo de espacio no pudo ser creado.");
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema: createTipoEspacioSchema,
    onSubmit: actionType == "create" ? handleSubmitCreate : handleSubmitEdit,
  });

  const { loadingAppData, tiposNormativa } = useSelector(
    (st: RootState) => st.appData,
  );

  useEffect(() => {
    resetForm();
    if (actionType) {
      renderInitialValues();
    }
  }, [actionType]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} size="lg" centered>
        <Modal.Header>
          <Modal.Title>
            {isEditMode ? "Editar Tipo de espacio" : "Nuevo Tipo de espacio"}
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <Col>
              <Row>
                <Col sm={6}>
                  <Input
                    id={"nombre"}
                    title="Nombre del espacio"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
                <Col sm={6}>
                  <Select
                    id={"con_sub_tipo"}
                    title="Con sub tipo:"
                    required
                    optionsFormatConfig={{ value: "value", label: "nombre" }}
                    options={Object.values(SI_NO_OPCIONES_SELECT)}
                    onChange={handleChange}
                    placeholder="Seleccionar"
                    width="100%"
                    variant="gray-container"
                    size="lg"
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="mx-3"
              variant="secondary"
              size="lg"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="lg"
              className="user-submit-button"
              /* disabled={isSubmitting} */ type="submit"
            >
              {isEditMode ? "Guardar Cambios" : "Confirmar"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
